var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-3",
        attrs: { content: "Datos de Escuela", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              label: "Escuela/Institución Actual:",
              value: _vm.model.studentDetail?.mipeStudent?.school
            }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              label: "Grado:",
              value: _vm.model.studentDetail?.mipeStudent?.grade
            }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              label: "Alternativa de Ubicación:",
              value: _vm.model.alternativeLocation
            }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: { label: "Enfoque:", value: _vm.model.focusType }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              label: "Región:",
              value: _vm.model.studentDetail?.mipeStudent?.schoolRegion
            }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              label: "Municipio:",
              value: _vm.model.studentDetail?.mipeStudent?.schoolMunicipality
            }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              label: "Diploma que Recibe:",
              value: _vm.model.schoolDiploma
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }